const State = {
  preferredTemplates: {},
  preferredSenders: {},
};

const Getters = {
  getPreferredTemplateName: (state) => (projectId) =>
    state.preferredTemplates[projectId],
  getPreferredSender: (state) => (projectId) =>
    state.preferredSenders[projectId],
};

const Mutations = {
  SET_PREFERRED_TEMPLATE(state, { projectId, templateName }) {
    state.preferredTemplates[projectId] = templateName;
    state.preferredTemplates = { ...state.preferredTemplates };
  },
  SET_PREFERRED_SENDER(state, { projectId, senderEmail }) {
    state.preferredSenders[projectId] = senderEmail;
    state.preferredSenders = { ...state.preferredSenders };
  },
};

export default {
  namespaced: true,
  state: State,
  getters: Getters,
  actions: {},
  mutations: Mutations,
};
